import { createSlice } from '@reduxjs/toolkit';
import {sampleColors} from "../../utils/colors";


const initialState = {

    siderVisible: true,

    selectedAppdataIds: {
        blacklist: null,
        screen: null,
    },
    etfColors: {},
    chartSeries: null,
    selectedPortfolio: null,

    comparison: {
        _maxTickers: 9,
        colors: {}
    },
    etfMatrix: {
        weights: {},
        positionTableMode: 'trunc'
    },

};

const appStatesSlice = createSlice({
  name: 'appStates',
  initialState,
  reducers: {


      toggleSider(state) {
        state.siderVisible = !state.siderVisible;
      },

      setEtfColors(state, action) {
        state.etfColors[action.payload.id] = action.payload.color;
      },


      /* ETF Matrix App State Config */

      updateEtfMatrixConfig(state, action) {
        state.etfMatrix = {
            ...state.etfMatrix,
            ...action.payload
        }
      },     // New Reducer to create a new ETF matrix
      createNewEtfMatrix(state, action) {
        state.etfMatrix = {
          weights: action.payload.weights || {}, // New weights for the ETFs
          positionTableMode: action.payload.positionTableMode || 'trunc' // Set the new mode or default to 'trunc'
        };
      },



  },
});

export const {
    setEtfColors,
    updateEtfMatrixConfig,
    createNewEtfMatrix,
    toggleSider,
} = appStatesSlice.actions;



export default appStatesSlice.reducer;





